import { isArray } from 'lodash'

const matchesRenderCondition = ({ field, form }) => {
  if (!field?.render?.ifFieldId) return false

  const comparedField = form[field.render.ifFieldId]
  if (!comparedField) return false

  const expectedValue = field.render.value
  const actualValue = comparedField.value

  if (isArray(expectedValue)) {
    return expectedValue.includes(actualValue)
  }

  return actualValue === expectedValue
}

export default matchesRenderCondition
